import React from "react";
import { connect } from "react-redux";
import { interfaceActions } from "../../../../common/redux/actions";
import * as licenseeActions from "../../redux/actions/licensee/licenseeActions";
import { Affix, Button, Col, Row, Skeleton } from "antd";
import LicenseeInfo from "../../components/Licensee/LicenseeInfo";
import showConfirmWindow from "../../../../common/components/confirmPopup/confirmPopup";
import { confirmUpdateProfile } from "../../components/MyProfile/confirm";
import { adjustLicenseeInfoData } from "../../api/licensee/adjustLicenseeInfoData";
import * as URLs from "../../../../common/constants/systemUrls";
const { getCompanyInfo, updateCompanyInfo } = licenseeActions;
const { setCaption } = interfaceActions;

class Licensee extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isEditable: false,
      formProgress: []
    };
    this.forms = {};
  }
  componentDidMount() {
    this.props.getCompanyInfo();
  }
  componentDidUpdate(prevProps) {
    if (
      this.state.isEditable &&
      this.props.updateSuccess !== prevProps.updateSuccess
    ) {
      this.handleCancelEdit();
    }
  }

  getForm = name => {
    if (this.forms.hasOwnProperty(name)) {
      return this.forms[name];
    }
    return false;
  };

  setForm = (name, form) => {
    if (form) {
      return (this.forms[name] = form);
    } else {
      delete this.forms[name];
      return false;
    }
  };

  handleClickEdit = () => {
    this.setState(state => ({
      isEditable: true
    }));
  };

  handleCancelEdit = () => {
    this.setState(state => ({
      isEditable: false
    }));
  };

  formSubmit = name => {
    const form = this.getForm(name);
    if (form) {
      form
        .validateFields((err, values) => {
          if (!err) {
            return values;
          } else {
            throw new Error(err);
          }
        })
        .then(values => {
          showConfirmWindow({
            ...confirmUpdateProfile,
            onOk: () => {
              this.props.updateCompanyInfo(values);
            }
          });
        })
        .catch(e => {
          console.error(e);
        });
    }
  };
  updateProfile = () => {
    this.formSubmit("formLicenseeInfo");
  };

  render() {
    const { companyInfo } = this.props;
    const { isEditable } = this.state;
    return (
      <div className="site-wrapper">
        <Row className="offer-create__form-wrap" style={{ display: "flex" }}>
          <Col
            span={18}
            className="order-create__form"
            style={{ paddingTop: 0 }}
          >
            {companyInfo ? (
              <LicenseeInfo
                name="formLicenseeInfo"
                companyInfo={companyInfo}
                data={adjustLicenseeInfoData(companyInfo)}
                getForm={this.getForm}
                setForm={this.setForm}
                isEditable={this.state.isEditable}
                dadataBankSelected={this.props.dadataBankSelected}
              />
            ) : (
              <Skeleton active />
            )}
          </Col>
          <Col span={6} className="offer-card__sidebar">
            <Affix
              offsetTop={18}
              target={() => document.getElementById("mainSheet")}
            >
              <>
                {!isEditable ? (
                  <>
                    <Button
                      type="primary"
                      htmlType="submit"
                      size="large"
                      className="offers-create__submit"
                      style={{ width: 176 }}
                      onClick={this.handleClickEdit}
                    >
                      Редактировать
                    </Button>
                  </>
                ) : (
                  <>
                    <Button
                      type="primary"
                      htmlType="submit"
                      size="large"
                      className="offers-create__submit"
                      style={{ width: 176 }}
                      onClick={this.updateProfile}
                    >
                      Сохранить
                    </Button>
                    <Button
                      type="primary"
                      htmlType="submit"
                      size="large"
                      className="offers-create__submit"
                      style={{
                        width: 176,
                        marginTop: 16,
                        borderColor: "#F5222D",
                        color: "#F5222D"
                      }}
                      ghost
                      onClick={this.handleCancelEdit}
                    >
                      Отмена
                    </Button>
                  </>
                )}
              </>
              <React.Fragment />
            </Affix>
          </Col>
        </Row>
      </div>
    );
  }
}

export default connect(
  state => ({
    dadataBankSelected: state.Customers.dadataBank.selected,
    companyId: state.Authorization.activeProfile.companyId,
    companyInfo: state.SystemSettings.licensee.info,
    updateSuccess: state.SystemSettings.licensee.updateSuccess
  }),
  {
    setCaption,
    getCompanyInfo,
    updateCompanyInfo
  }
)(Licensee);
